import { z } from 'zod'

import { followWelcomeTriggerSchema } from 'shared/api/requests/tiktok/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export const TikTokFollowWelcomeSocketEventsSchemas = {
  triggerUpdated: SocketEventBaseSchema.extend({
    event: z.literal('tt_follow_reply_updated'),
    model: followWelcomeTriggerSchema,
  }),
}
